import React, { ReactElement, useState } from 'react';
import { isEmpty } from 'ts-utils';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { onSingleSelectSubmit } from './SingleSelectScreen';
import { DropdownSelectLayout, DropdownSelectLayoutConfig } from './layouts/DropdownSelectLayout';
import { LayoutActions } from './layouts/LayoutActions';

export type DropdownSelectScreenLayoutConfig = DropdownSelectLayoutConfig & {
  primaryButtonTitle: string;
};

export type DropdownSelectScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.DropdownSelect,
  DropdownSelectScreenLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  DropdownSelectScreenConfig<ScreenNames>,
  ScreenNames
>;

/** A single-answer question picked from a native dropdown; stores the option's `value`. */
export const DropdownSelectScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const { layout } = props;
  const [selectedValue, setSelectedValue] = useState<string>('');

  function onSubmitPress() {
    if (isEmpty(selectedValue)) return;
    onSingleSelectSubmit({ props, selected: selectedValue });
  }

  return (
    <ScreenWrapper>
      <DropdownSelectLayout
        heading={layout.heading}
        question={layout.question}
        options={layout.options}
        placeholder={layout.placeholder}
        onSelected={setSelectedValue}
      />
      <LayoutActions
        primaryButtonTitle={layout.primaryButtonTitle}
        onPressPrimaryButton={onSubmitPress}
        primaryButtonDisabled={isEmpty(selectedValue)}
      />
    </ScreenWrapper>
  );
};
